module.exports = __webpack_public_path__ + "static/media/my-bid-cart.1d527122.svg";